module.exports = __webpack_public_path__ + "img/yangji.1bfdd253.png";